<!-- <app-spinner *ngIf="load" [loading]="load" [fullScreen]="true" [text]="''"></app-spinner> -->


<app-spinner *ngIf="loading" [loading]="loading" [text]="loadingMessage" [fullScreen]="true"></app-spinner>
